import { render, staticRenderFns } from "./featurecenteredgrid.vue?vue&type=template&id=44205c0a&"
import script from "./featurecenteredgrid.vue?vue&type=script&lang=js&"
export * from "./featurecenteredgrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/components/kirbyimage.vue').default})
